import React from 'react';
import { Calculator, ArrowRight, Sparkles } from 'lucide-react';

export const CalculatorBanner = ({ onOpen }) => (
  <button
    onClick={onOpen}
    data-testid="calculator-top-banner"
    className="group w-full block relative overflow-hidden bg-gradient-to-r from-emerald-600 via-teal-600 to-emerald-500 hover:from-emerald-500 hover:via-teal-500 hover:to-emerald-400 transition-all text-white text-left"
  >
    {/* Camadas decorativas */}
    <div className="absolute inset-0 opacity-20 pointer-events-none">
      <div className="absolute -top-8 -left-10 w-40 h-40 rounded-full bg-white/30 blur-3xl" />
      <div className="absolute -bottom-8 right-10 w-48 h-48 rounded-full bg-teal-200/40 blur-3xl" />
    </div>

    <div className="container-apex relative py-4 sm:py-5 md:py-7 flex flex-col sm:flex-row items-stretch sm:items-center justify-center gap-3 sm:gap-6">
      <div className="flex items-center gap-3 sm:gap-4 flex-1 sm:flex-initial">
        <div className="relative flex-shrink-0">
          <div className="absolute inset-0 rounded-full bg-white/40 blur-md animate-ping" style={{ animationDuration: '2.5s' }} />
          <div className="relative w-10 h-10 sm:w-12 sm:h-12 md:w-14 md:h-14 rounded-full bg-white/95 flex items-center justify-center shadow-lg">
            <Calculator className="w-5 h-5 sm:w-6 sm:h-6 md:w-7 md:h-7 text-emerald-700" />
          </div>
        </div>
        <div className="text-left min-w-0 flex-1">
          <div className="flex items-center gap-1.5 text-[10px] sm:text-xs uppercase tracking-widest font-semibold text-white/90">
            <Sparkles className="w-3 h-3 flex-shrink-0" />
            Ferramenta gratuita
          </div>
          <p className="font-heading font-bold text-base sm:text-lg md:text-2xl leading-tight">
            Quanto você paga a mais de imposto?
          </p>
          <p className="text-xs md:text-sm text-white/85 hidden md:block">
            Compare 6 cenários e descubra sua economia em 1 minuto.
          </p>
        </div>
      </div>

      <span className="inline-flex items-center justify-center gap-2 bg-white text-emerald-700 font-bold px-5 md:px-7 py-3 md:py-3.5 rounded-full text-sm md:text-base shadow-lg group-hover:shadow-xl group-hover:scale-[1.03] transition-transform w-full sm:w-auto">
        Calcular meus impostos
        <ArrowRight className="w-4 h-4 md:w-5 md:h-5" />
      </span>
    </div>
  </button>
);
